


















import CoIcon from '../co-icon/CoIcon.vue';

export default {
    name: 'CoRoundButton',
    components: {
        CoIcon,
    },
    props: {
        variant: {
            type: String,
            default: 'primary',
            required: false,
            validator(value) {
                return (
                    [
                        'primary',
                        'secondary',
                        'secondary-light',
                        'secondary-black',
                        'warning',
                        'danger',
                        'success',
                        'light',
                        'dark',
                        'dark-outline',
                        'icon',
                        'outline',
                        'subtle',
                    ].indexOf(value) !== -1
                );
            },
        },
        to: {
            type: String,
            required: false,
            default: '',
        },

        badge: {
            type: Boolean,
            required: false,
            default: false,
        },

        icon: {
            type: String,
            required: false,
            default: 'bell',
        },

        label: {
            type: String,
            required: false,
            default: '',
        },
        iconSize: {
            type: String,
            required: false,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        active: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    // emits: ['click'],

    data() {
        return {
            // isHovered: false
        };
    },

    methods: {
        click(event) {
            if (this.disabled) {
                if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                return;
            }
            this.$emit('click', event);
            event.currentTarget.blur();
            if (this.to) {
                this.$router.push(this.to);
            }
        },
    },
};
